import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionsEvent from '../../event/redux/actions';
import AdminLayout from '../AdminLayout';

import Form from './Form';
import { STATUS, EVENT, formatEvent, SETEVENT } from './Constants';
import { uploadFiles, removeFiles } from './UploadImage';
import { IMAGES_URL } from '../../../helper/api/Api';
import { API } from '../../../helper/api';
import { createPrices } from './Create';


export class UpdateEvent extends Component {
  static propTypes = {

  };

  reset = () => ({
    deleted: [],
    saved: [],
    added: []
  })

  state = {
    event: EVENT(),
    prices: this.reset(),
    moderators: this.reset(),
    files:[],
    filesToRemove: [],
    visible_modal: false,
    loading: false
  }

  componentWillMount() {
    this.getEvent();
  }

  getEvent() {
    this.props.actions.getEvent(this.props.match.params.id, { images: 'True', categories: 'True', moderators: 'True', prices: 'True', restricted : 'True'})
        .then((res) => {
          this.setState({ prices: { ...this.reset(), saved: res.data.event.prices.map(p => ({role: p.roleId, amount: p.amount, id: p.id }))}})

          return res;
        })
        .then((res) => this.setState({ moderators: { ...this.reset(), saved: res.data.event.moderators.map(m => ({ id: m.id, key: m.user.id, label: [ m.user.firstName + ' ' + m.user.lastName.toUpperCase() ] }))}}))
  }

  componentWillReceiveProps(props) {
    if (props.event.current_item 
     && this.props.event.current_item !== props.event.current_item 
     && props.event.current_item.event)
      this.setState({ event: SETEVENT(props.event.current_item.event) })
  }

  getFiles(type = 'both'){
    if(type === 'saved')
      return this.state.event.images.map(i => ({...i, uid : i.imageId, url: IMAGES_URL(i.url) }))
    else if (type === 'local')
      return this.state.files
    else
      return [ ...this.getFiles('saved'),  ...this.getFiles('local') ]
  }

  getPrices(type = 'all'){
    if(type !== 'all')
      return this.state.prices[type];
    
    return [ ...this.getPrices('saved').filter(p => !this.getPrices('deleted').map(r => r.role).includes(p.role)),  ...this.getPrices('added') ]
  }

  getModerators(type = 'all'){
    if(type !== 'all')
      return this.state.moderators[type];
    
    return [ ...this.getModerators('saved').filter(p => !this.getModerators('deleted').map(r => r.key).includes(p.key)),  ...this.getModerators('added') ]
  }

  onClick = (status, isPublish = false) => {
    this.setState({ loading: true });
    this.props.actions.setEvent(this.state.event.id, formatEvent(this.state.event, status))
      .then(() => this.state.files.length > 0 ? uploadFiles(this.state.event.id, this.state.files) : false )
      .then(() => this.setState({ files: [] }))
      .then(() => this.state.filesToRemove.length > 0 ? removeFiles(this.state.event.id, this.state.filesToRemove) : false )
      .then(() => this.setState({ filesToRemove: [] }))
      .then(() => this.getPrices('deleted').filter(p => !!p.id))
      .then((deletedPrices) => Promise.all(deletedPrices.map(price => API.delete('/price/'+ price.id))))
      .then(() => createPrices(this.getPrices('added'), this.state.event.id))
      .then(() => this.getModerators('saved').filter(p => this.getModerators('deleted').map(r => r.key).includes(p.key)))
      .then((deletedModerators) => Promise.all(deletedModerators.map(m => API.delete('/user/temporary_role/' + m.id))))
      .then(() => this.getModerators('added'))
      .then((addedModerators) => Promise.all(addedModerators.map(m => API.post('/user/temporary_role/' + m.key + '/' + this.props.admin.ROLE_ID.MODERATOR + '/' + this.props.match.params.id))))
      .then(() => this.setState(({prices}) => ({ prices: { ...prices, deleted: [], added: [] }})))
      .then(() => isPublish ? this.setState(({ event }) => ({ event: { ...event, status : STATUS.PUBLISH }})) : false )
      .then(() => this.getEvent())
      .catch(() => this.getEvent())
      .then(() => this.setState({ loading: false }))
  }


  render() {
    const buttons = 
      this.state.event.status === STATUS.DRAFT ?
      [
      {
        onClick: () => this.props.actions.deleteEvent(this.state.event.id)
          .then(() => this.props.history.push("/admin/events"))
        ,
        confirmation : true,
        icon: "delete",
        type: "danger"
      },
      {
        icon: "eye-o",
        type: "dashed",
        onClick: () => this.setState({visible_modal : true})
      },
      {
        onClick: () => this.onClick(STATUS.DRAFT),
        icon: "save",
        name: "SAUVEGARDER",
        type: "default"
      },
      {
        onClick: () => this.onClick(STATUS.PENDING),
        icon: "cloud-upload",
        name: "PUBLIER",
      }
      ]
      :
      [
        {
          onClick: () => this.props.history.push('/admin/events/registration/'+this.state.event.id)
          ,
          type: "default",
          name: "INSCRIPTION",
          disabled: this.state.event.subscribeNumber === 0
        },
        {
          icon: "eye-o",
          type: "dashed",
          onClick: () => this.setState({visible_modal : true})
        },
        {
          onClick: () => this.props.actions.deleteEvent(this.state.event.id)
            .then(() => this.props.history.push("/admin/events"))
          ,
          confirmation : true,
          icon: "delete",
          type: "danger"
        },
        {
          onClick: () => this.onClick(STATUS.PENDING),
          icon: " edit",
          name: "METTRE À JOUR"
        }
      ]
    return (
      <AdminLayout
        title="MODIFIER UN ÉVÉNEMENT"
        back="/admin/events"
        buttons={ buttons }
      >

        <Form
          id={this.props.match.params.id}
          loading={!this.state.event.id || this.props.event.status.getEvent.pending || this.state.loading}
          event={this.state.event}
          files={ this.getFiles() }
          prices={ this.getPrices() }
          moderators={ this.getModerators() }
          addFile={(file) => this.setState(({ files }) => ({ files: [...files, file ] }))}
          removeFile={(file) => {
            this.setState(() => {
              const filesSaved =  this.state.event.images.filter(e => e.imageId !== file.uid);
              const filesLocal =  this.getFiles('local').filter(e => e.uid !== file.uid);

              if(filesSaved.length !==  this.state.event.images.length){
                return ({
                  event:{
                    ...this.state.event,
                    images: filesSaved
                  },
                  filesToRemove: [ ...this.state.filesToRemove, file.uid ]
                })
              }
              else if (filesLocal.length !== this.state.files.length) {
                return ({
                  files:  filesLocal
                })
              }
            });
          }}
          addPrice={(price) => this.setState(({ prices }) => ({ prices: {...prices, added: [...prices.added, price] } }))}
          removePrice={(price) => {
            if(price.id)
              this.setState(({ prices }) => ({ prices: {...prices, deleted: [...prices.deleted, price] } }))
            else
              this.setState(({ prices }) => ({ prices: {...prices, added: prices.added.filter(p => p.role !== price.role )} }))
          }}
          addModerator={(moderator) => {
            this.setState(({ moderators }) => ({ moderators: {...moderators, added: [...moderators.added, moderator] } }))
          }}
          removeModerator={(moderator) => {
            if(this.getModerators('saved').filter(m => m.key === moderator.key).length > 0 && this.getModerators('deleted').filter(m => m.key === moderator.key).length === 0)
              this.setState(({ moderators }) => ({ moderators: {...moderators, deleted: [...moderators.deleted, moderator] } }))
            else
              this.setState(({ moderators }) => ({ moderators: {...moderators, added: moderators.added.filter(p => p.key !== moderator.key )} }))
          }}
          //onModeratorChange={(moderators) => this.setState({ moderators })}
          onEventChange={(value) => this.setState({ event: Object.assign(this.state.event, value) })}
          preview={this.state.visible_modal}
          closePreview={() => this.setState({visible_modal : false})}
        />
      </AdminLayout>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    admin: state.admin,
    event: state.event,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actionsEvent }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdateEvent);


// WEBPACK FOOTER //
// ./src/features/admin/events/Update.js